(function() { window.GUID_098a27c6_05b0_4129_9c5b_a1f8bd0e0f0f = { getGuid: function() { return "098a27c6-05b0-4129-9c5b-a1f8bd0e0f0f"; } }; })();
var Menu;
(function (Menu) {
    Menu.csMainMenuButton = $('#CSMainMenuButton');
    Menu.csMainMenuIcon = $('.Icon', Menu.csMainMenuButton);
    Menu.mainMenu = $('#MainMenu');
    var headers = $('.MenuPath>.MenuItemsHeader', Menu.mainMenu);
    var highlightedMenu = $('.IsHighlighted', Menu.mainMenu);
    Menu.masterContainer = $('#MasterContainer');
    Menu.toolBarContainer = $('#ToolBarContainer');
    Menu.preventHideMenu = false;
    Menu.mainMenu.on('mousedown', function (e) {
        // Ne pas arreter la propagation si on enregistre des tutoriels
        // if (typeof (isRecordingTutorial) == "undefined" || isRecordingTutorial != true) {
        e.stopPropagation();
        // }
    });
    headers.on('click', function (e) {
        var header = $(this);
        var parent = header.parent();
        var openCloseButton = $('>.PlusMinus', header);
        var menuItems = $('>.MenuItems', parent);
        var state = '';
        if (menuItems.is(":visible")) {
            menuItems.slideUp(250, function () {
                openCloseButton.html("+");
            });
            state = 'IsClosed';
        }
        else {
            menuItems.slideDown(250, function () {
                openCloseButton.html("-");
            });
            state = 'IsOpened';
        }
        CallKeepMenuState(parent[0].id, state);
    });
    function ExpandMenuHeader(header) {
        var parent = header.parent();
        var openCloseButton = $('>.PlusMinus', header);
        var menuItems = $('>.MenuItems', parent);
        var state = '';
        if (!menuItems.is(":visible")) {
            menuItems.slideDown(250, function () {
                openCloseButton.html("-");
            });
            state = 'IsOpened';
        }
        CallKeepMenuState(parent[0].id, state);
    }
    Menu.csMainMenuButton.on('click', function (e) {
        e.stopPropagation();
        if (IsDefined(typeof (ShowHideMenu))) {
            if (Menu.mainMenu.css('display') == "none") {
                ShowHideMenu(true);
            }
            else {
                ShowHideMenu(false);
            }
        }
    });
    /*window.onblur = function () {
        ShowHideMenu(false);
    };*/
    function ShowHideMenu(show) {
        if (IsDefined(typeof (Menu.desktop))) {
            Menu.desktop.ShowHideMenu(show);
        }
    }
    Menu.ShowHideMenu = ShowHideMenu;
    //function ShowHideMenu(show) {
    //    if (show || (mainMenu.is(':visible') && show == false)) {
    //        //CallKeepMenuState("MainMenu", show ? 'IsOpened' : 'IsClosed');
    //        if (show) {
    //            //if (!(typeof silverlightCtl === "undefined") && silverlightCtl != null)
    //            //masterContainer.animate({ 'left': '13.5em' }, 250);
    //            //toolBarContainer.animate({ 'left': '0' }, 250);
    //            mainMenu.show("slide", { direction: "left" }, 250, function () {
    //                csMainMenuButton.addClass('IsOpened');
    //            });
    //            CS.trigger("menuShow");
    //        } else {
    //            //if (!(typeof silverlightCtl === "undefined") && silverlightCtl != null)
    //            //masterContainer.animate({ 'left': '0' }, 250);
    //            //toolBarContainer.animate({ 'left': '120px' }, 250);
    //            toolBarContainer.show();
    //            mainMenu.hide("slide", { direction: "left" }, 250, function () {
    //                csMainMenuButton.removeClass('IsOpened');
    //            });
    //        }
    //    }
    //}
    function CallKeepMenuState(id, state) {
        if (CSParameters.IsConnected) {
            var data = {
                keyName: id,
                value: state,
                noSportEventId: true,
                controllerName: "CSBaseController"
            };
            CompuSport.Ajax.Post(CSParameters.BaseUrl + 'Global/SaveUserData/' + CSParameters.SportEventId, data, function () {
            });
        }
    }
    //TEST, doit etre flusher
    $('#SubMenu23').on('click', function (e) {
        e.preventDefault();
    });
    /**
     * The score sheet finder entry has no page of its own: it opens the finder over
     * whatever page the user is on. Its bundle only ships with the pages that embed
     * the finder, so it is fetched the first time the entry is used and never again.
     */
    const scoreSheetFinderMenuItemId = "ManageScoreSheetFinder";
    let scoreSheetFinderIsLoading = false;
    CS.on("click", "#" + scoreSheetFinderMenuItemId, function (e) {
        e.preventDefault();
        ShowHideMenu(false);
        LoadScoreSheetFinder(function () {
            ScoreSheetFinder.browse();
        });
    });
    function LoadScoreSheetFinder(callback) {
        try {
            if (typeof ScoreSheetFinder !== "undefined") {
                callback();
                return;
            }
            if (scoreSheetFinderIsLoading) {
                return;
            }
            // The tags are rendered by the master page, so the urls carry the version
            // the rest of the bundles are served with. They live in the content of a
            // template, which is a fragment of its own rather than part of the page.
            // A bundle is only served as a single file once it is minified: until then
            // it is one tag per source file, so there is a list of urls to load here.
            const template = document.getElementById("ScoreSheetFinderBundles");
            const bundles = template === null || template === void 0 ? void 0 : template.content;
            const styleUrls = GetBundleUrls(bundles, "link", "href");
            const scriptUrls = GetBundleUrls(bundles, "script", "src");
            if (!scriptUrls.length) {
                throw new Error("Score sheet finder bundle is not defined");
            }
            for (const styleUrl of styleUrls) {
                if (!$("head").find(`link[href="${styleUrl}"]`).length) {
                    $("<link rel='stylesheet' />").attr("href", styleUrl).appendTo("head");
                }
            }
            scoreSheetFinderIsLoading = true;
            let pending = scriptUrls.length;
            for (const scriptUrl of scriptUrls) {
                const script = document.createElement("script");
                // An appended script runs as soon as it arrives unless it is told to
                // wait its turn, and the finder is split over files that build on each
                // other. The finder is only ready once the last one has run.
                script.async = false;
                script.onload = function () {
                    pending--;
                    if (pending === 0) {
                        scoreSheetFinderIsLoading = false;
                        callback();
                    }
                };
                script.onerror = function () {
                    // The finder is incomplete, so the count is left short on purpose.
                    pending = -1;
                    scoreSheetFinderIsLoading = false;
                    console.error("Error while loading " + scriptUrl);
                };
                script.src = scriptUrl;
                document.body.appendChild(script);
            }
        }
        catch (error) {
            scoreSheetFinderIsLoading = false;
            console.error("Error while loading the score sheet finder", error);
        }
    }
    /** The urls a bundle rendered into, in the order it declared them. */
    function GetBundleUrls(bundle, tag, urlAttribute) {
        const urls = [];
        const tags = bundle ? bundle.querySelectorAll(tag) : [];
        for (let i = 0; i < tags.length; i++) {
            const url = tags[i].getAttribute(urlAttribute);
            if (url) {
                urls.push(url);
            }
        }
        return urls;
    }
    //var mainMenuScroll = GetCookieValue(CSParameters.SportEventId, "MainMenuScroll");
    //if (mainMenuScroll != null) {
    //    mainMenu.scrollTop(mainMenuScroll);
    //}
    CS.doc.on('mousedown.mainmenu', function () {
        if (Menu.preventHideMenu) {
            return;
        }
        if (IsDefined(typeof (ShowHideMenu))) {
            ShowHideMenu(false);
        }
    });
    var csMainMenuButtonStartPosition = null;
    var mainMenuStartPosition = null;
    function PushMenuDownForHintMessage(hintHeight) {
        if (csMainMenuButtonStartPosition == null) {
            csMainMenuButtonStartPosition = Menu.csMainMenuButton.css('top');
            if (csMainMenuButtonStartPosition != null) {
                csMainMenuButtonStartPosition = parseFloat(csMainMenuButtonStartPosition.replace("px", ""));
            }
            else {
                csMainMenuButtonStartPosition = 0;
            }
        }
        if (mainMenuStartPosition == null) {
            mainMenuStartPosition = Menu.mainMenu.css('top');
            if (mainMenuStartPosition != null) {
                mainMenuStartPosition = parseFloat(mainMenuStartPosition.replace("px", ""));
            }
            else {
                mainMenuStartPosition = 0;
            }
        }
        Menu.csMainMenuButton.animate({ 'top': csMainMenuButtonStartPosition + hintHeight + 10 }, 300);
        Menu.mainMenu.animate({ 'top': mainMenuStartPosition + hintHeight + 10 }, 300);
    }
    Menu.PushMenuDownForHintMessage = PushMenuDownForHintMessage;
    function PullMenuUpForHintMessage() {
        Menu.csMainMenuButton.animate({ 'top': csMainMenuButtonStartPosition }, 300);
        Menu.mainMenu.animate({ 'top': mainMenuStartPosition }, 300);
    }
    Menu.PullMenuUpForHintMessage = PullMenuUpForHintMessage;
})(Menu || (Menu = {}));

//# sourceMappingURL=Menu.js.map
